<template>
  <Popup :visible="visible" @close="$emit('close')"
         :title="'Paramètres'"  
         :add="false"
         :noButtons="true"
         @delete="$emit('delete', event); $emit('close')" 
         @add="saveEvent(); $emit('close')" 
         @update="saveEvent(); $emit('close')"    
  >
    <div class="w-fit h-full flex flex-col overflow-hidden">
      <div class="flex flex-col flex-grow gap-8">
        <div class="relative w-full mt-2 text-left">
          <span class="text-left w-full bg-white px-1 font-bold text-md text-gray-500">Jour de congés</span>
          <div class="flex justify-between items-center gap-2 mt-1 h-12">
            <button type="button"
              v-for="(day, index) in daysOfWeek"
              :key="index"
              :class="['!rounded-full !w-10 !h-10 flex items-center justify-center', isDayOff(index) ? '!bg-[#E8535D] text-white' : '!bg-gray-200 text-gray-700']"
              @click="toggleDayOff(index)"
            >
              {{ day }}
            </button>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <span class="text-left w-full bg-white px-1 font-bold text-md text-gray-500">Horaires</span>
          <!-- Debut -->
          <div class="flex gap-2">
            <!-- Heure -->
            <div class="relative w-full">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Début de journée</span>
              <input type="time"
                  v-model="startTime"
                  placeholder="Dupont"
                  class="w-full basicInput"
                  ref="focusInput"
                  required
              >
            </div>
            <!-- Heure -->
            <div class="relative w-full">
              <span class="absolute -top-2 left-2 bg-white px-1 text-xs text-gray-500">Fin de journée</span>
              <input type="time"
                  v-model="endTime"
                  placeholder="Dupont"
                  class="w-full basicInput"
                  ref="focusInput"
                  required
              >
            </div>
          </div>
        </div>
        <!-- Heure -->
        <div class="relative text-left flex flex-col">
          <span class=" text-left w-full bg-white px-1 font-bold text-md text-gray-500 mb-1">Afficher les heures de nuit</span>
          <CustomCheckbox :modelValue="toggleNight" class="ml-1 h-9 !w-9" @update:modelValue="toggleNight = $event"/>
        </div>
      </div>
    </div>
  </Popup>
</template>

  
<script>
import Popup from '@/components/Popups/Popup.vue';
import CustomCheckbox from '../Others/CustomCheckbox.vue';

import { updateRessource } from '@/services/ressourceService';

import { inject } from 'vue';

export default {
  props: ['event', 'project', 'visible'],
  components: {
    Popup,
    CustomCheckbox,
  },
  setup() {
    const state = inject('state');
    const parameters = inject('parameters');
    return { state, parameters };
  },
  emits: ['delete', 'close'],
  data() {
    return {
      startTime: this.minutesToTime(this.parameters.startMinute),
      endTime: this.minutesToTime(this.parameters.endMinute),
      daysOfWeek: ['L.', 'M.', 'M.', 'J.', 'V.', 'S.', 'D.'],
      toggleNight: this.parameters.night,
    };
  },
  methods: {
    isDayOff(index) {
      const realIndex = (index + 1) % 7; // Décale l'index pour que lundi = 0
      return this.parameters.daysOff.includes(realIndex);
    },
    // Active ou désactive un jour de congé
    toggleDayOff(index) {
      const realIndex = (index + 1) % 7; // Décale l'index pour que lundi = 0
      if (this.isDayOff(index)) {
        this.parameters.daysOff = this.parameters.daysOff.filter(day => day !== realIndex); // Retire le jour
      } else {
        this.parameters.daysOff.push(realIndex); // Ajoute le jour
      }
    },
    setDatas(){
      
    },
    minutesToTime(minutes) {
      const hours = Math.floor(minutes / 60).toString().padStart(2, '0');
      const mins = (minutes % 60).toString().padStart(2, '0');
      return `${hours}:${mins}`;
    },

    // Convertit un format HH:mm en minutes
    timeToMinutes(time) {
      const [hours, mins] = time.split(':').map(Number);
      return hours * 60 + mins;
    },
  },
  watch:{
    visible: {
      handler() {
        // À chaque changement de 'event', on appelle setDatas
        this.setDatas();
      },
      immediate: true, // Appeler la fonction immédiatement lors de la première exécution
      deep: true, // Observer les changements profonds de l'objet
    },
    startTime: function(newValue) {
      this.parameters.startMinute = this.timeToMinutes(newValue);
    },
    endTime: function(newValue) {
      this.parameters.endMinute = this.timeToMinutes(newValue);
    },
    parameters: {
      handler() {
        this.startTime = this.minutesToTime(this.parameters.startMinute);
        this.endTime = this.minutesToTime(this.parameters.endMinute);
        this.toggleNight = this.parameters.night;
      },
      deep: true, // Observer les changements profonds de l'objet
      immediate: true, // Appeler la fonction immédiatement lors de la première
    },
    toggleNight: {
      handler() {
        console.log(this.toggleNight);
        this.parameters.night = this.toggleNight;
      },
    },
  }
};
</script>


  
<style scoped>
.bg-red-200 {
  background-color: #fecaca !important;
}
table {
  border-collapse: separate; /* Nécessaire pour utiliser border-radius */
  border-spacing: 0;
}

button {
  transition: background-color 0.3s, color 0.3s;
}

/* Arrondir le coin supérieur gauche et supérieur droit du header */
thead tr th:first-child {
  border-top-left-radius: 8px;
}
thead tr th:last-child {
  border-top-right-radius: 8px;
}

/* Coins inférieurs de la dernière ligne */
tbody tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}
tbody tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}
</style>